@if (breakpointService.isDesktop()) {
  <ng-container [ngTemplateOutlet]="desktopTemplate"></ng-container>
} @else {
  <ng-container [ngTemplateOutlet]="mobileTemplate"></ng-container>
}

<ng-template #mobileTemplate>
  <div class="mobile-dialog occasion-genius-dialog">
    <div class="mobile-dialog__header">
      <h2 class="mobile-dialog__header--title">
        {{ selectedEvent.name }}
      </h2>
      <button class="mobile-dialog__header--close" (click)="dialogRef.close()">
        <mat-icon [svgIcon]="eSvgIcons.CLOSE_THIN"></mat-icon>
      </button>
    </div>
    <div class="mobile-dialog__content">
      <p class="mobile-dialog__content--normal">
        {{ selectedEvent.description }}
      </p>
      <p class="mobile-dialog__content--date">
        @if (isOneEvent) {
          {{ formattedEventDate(selectedEvent.start_date, selectedEvent.end_date) }}
        } @else {
          <p class="mobile-dialog__content--bold">{{ 'OCCASION_GENIUS.VIEW_DATE' | translate }}:</p>
          <mat-select [(ngModel)]="selectedEvent" placeholder="Rating">
            <mat-select-trigger>
              {{ formattedEventDate(selectedEvent.start_date, selectedEvent.end_date) }}
            </mat-select-trigger>
            @for (event of data.events; track event.uuid) {
              <mat-option [value]="event">{{ formattedEventDate(event.start_date, event.end_date) }}</mat-option>
            }
          </mat-select>
        }
      </p>
      <p class="mobile-dialog__content--normal">
        @if (selectedEvent.address) {
          {{ 'OCCASION_GENIUS.ADDRESS' | translate }}:  <span class="mobile-dialog__content--bold">{{ selectedEvent.address }}</span>
        } @else {
          {{ 'OCCASION_GENIUS.COORDS' | translate }}: <span class="mobile-dialog__content--description mobile-dialog__content--bold">{{ selectedEvent.latitude }}, {{ selectedEvent.longitude }}</span>
        }
      </p>
      <div class="mobile-dialog__content--media">
        <figure class="mobile-dialog__content--figure">
          <img [src]="selectedEvent.image_url | safeUrl" alt="event-image">
        </figure>
        <div class="mobile-dialog__content--map">
          <app-occasion-genius-map [event]="selectedEvent"></app-occasion-genius-map>
        </div>
      </div>
    </div>
    <div class="mobile-dialog__footer">
      <button class="btn-default btn-icon btn-border"
              (cdkCopyToClipboardCopied)="copiedToClipboardHandler()"
              [cdkCopyToClipboard]="selectedEvent.source_url">
        <mat-icon [svgIcon]="eSvgIcons.SHARE_V2"></mat-icon>
      </button>
      <a [href]="selectedEvent.source_url" target="'_blank'" class="btn-default btn-blue" (click)="setGoogleAnalytic()">
        {{ 'OCCASION_GENIUS.SEE_MORE' | translate }}
      </a>
    </div>
  </div>
</ng-template>

<ng-template #desktopTemplate>
  <div class="dialog">
    <button class="dialog__close-btn" (click)="dialogRef.close()"></button>

    <div class="dialog__content">
      <div class="occasion-genius-dialog">
        <div class="occasion-genius-dialog__media">
          <figure class="occasion-genius-dialog__image">
            <img [src]="selectedEvent.image_url | safeUrl" alt="">
          </figure>
          <div class="occasion-genius-dialog__map">
            <app-occasion-genius-map [event]="selectedEvent"></app-occasion-genius-map>
          </div>
        </div>
        <div class="occasion-genius-dialog__content">
          <h2 class="occasion-genius-dialog__title">
            {{ selectedEvent.name }}
          </h2>
          <p class="occasion-genius-dialog__description">
            {{ selectedEvent.description }}
          </p>

          <div class="occasion-genius-dialog__date">
            @if (isOneEvent) {
              {{ formattedEventDate(selectedEvent.start_date, selectedEvent.end_date) }}
            } @else {
              <p>{{ 'OCCASION_GENIUS.VIEW_DATE' | translate }}:</p>
              <mat-select [(ngModel)]="selectedEvent" placeholder="Rating">
                <mat-select-trigger>
                  {{ formattedEventDate(selectedEvent.start_date, selectedEvent.end_date) }}
                </mat-select-trigger>
                @for (event of data.events; track event.uuid) {
                  <mat-option [value]="event">{{ formattedEventDate(event.start_date, event.end_date) }}</mat-option>
                }
              </mat-select>
            }
          </div>

          <div class="occasion-genius-dialog__place">
            @if (selectedEvent.address) {
              {{ 'OCCASION_GENIUS.ADDRESS' | translate }}: {{ selectedEvent.address }}
            } @else {
              {{ 'OCCASION_GENIUS.COORDS' | translate }}: {{ selectedEvent.latitude }}, {{ selectedEvent.longitude }}
            }
          </div>

        <div class="occasion-genius-dialog__actions">
          <a [href]="selectedEvent.ticket_url || selectedEvent.source_url" target="'_blank'" class="btn-default btn-blue" (click)="setGoogleAnalytic()">
            {{'OCCASION_GENIUS.SEE_MORE' | translate}}
          </a>
          <button class="btn-default btn-icon"
                  (cdkCopyToClipboardCopied)="copiedToClipboardHandler()"
                  [cdkCopyToClipboard]="selectedEvent.ticket_url || selectedEvent.source_url">
            <mat-icon [svgIcon]="eSvgIcons.SHARE"></mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
